export const SPLIT_ELEMENT_CLASS = {
  BEFORE_ELEMENT: "-before-element",
  AFTER_ELEMENT: "-after-element",
} as const;
